<template>
  <div v-if="promotionActive && promotionStartDateCheck && promotionEndDateCheck" class="flex flex-col text-xs">
    <span v-if="promotionEndDate" class="font-bold text-[color:var(--color-primary)]">
      {{ $t("shared.catalog.product_card.available_until", [promotionEndDate]) }}</span
    >
    <span v-if="promotionType != 'Highlight'">{{ $t("shared.catalog.product_card.while_in_stock") }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useLanguages } from "@/core/composables";
import { getDynamicPropertyValue } from "@/core/utilities";
import type { Property } from "@/core/api/graphql/types";
import type { PropType } from "vue";

const props = defineProps({
  properties: {
    type: Object as PropType<Property[] | undefined>,
    required: true,
  },
});

const { currentLanguage } = useLanguages();

const PROMOTION_ACTIVE_PROPERTY = "promotionactive_property";
const PROMOTION_START_DATE_PROPERTY = "promotionstartdate_property";
const PROMOTION_END_DATE_PROPERTY = "promotionenddate_property";

const promotionActive = computed<boolean>(
  () => getDynamicPropertyValue(props.properties, PROMOTION_ACTIVE_PROPERTY) ?? false,
);

const promotionEndDate = computed(() => {
  const endDateValue: string = getDynamicPropertyValue<string>(props.properties, PROMOTION_END_DATE_PROPERTY) ?? "";

  const endDate = new Date(endDateValue);

  if (endDateValue && endDate) {
    const day = endDate.getDate();
    const month = endDate.toLocaleString(currentLanguage.value!.cultureName, { month: "long" });

    return `${day} ${month}`;
  } else {
    return "";
  }
});

const promotionStartDateCheck = computed<boolean>(() => {
  const startDateProperty: string | undefined = getDynamicPropertyValue<string>(
    props.properties,
    PROMOTION_START_DATE_PROPERTY,
  );

  const now = new Date();
  if (startDateProperty) {
    const target = new Date(startDateProperty);

    return now > target;
  } else {
    return true;
  }
});

const promotionEndDateCheck = computed<boolean>(() => {
  const endDateProperty: string | undefined = getDynamicPropertyValue<string>(
    props.properties,
    PROMOTION_END_DATE_PROPERTY,
  );

  const now = new Date();
  if (endDateProperty) {
    const target = new Date(endDateProperty);

    return target > now;
  } else {
    return true;
  }
});

const PROMOTION_TYPE_PROPERTY = "promotiontype_property";
const promotionType = computed<string>(() => getDynamicPropertyValue(props.properties, PROMOTION_TYPE_PROPERTY) ?? "");
</script>
